// @ts-nocheck
import React from 'react';
import { Dialog, DialogSuspense } from '@/components';
import withDialogRedux from '@/components/DialogReduxConnect';
import { compose } from '@/utils';

const PoTrackingDialogContent = React.lazy(() => import('./PoTrackingDialogContent'));

function PoTrackingDialog({
  dialogName,
  payload: { poId = null, poNumber = '' } = {},
  isOpen,
}) {
  return (
    <Dialog
      name={dialogName}
      title={poNumber ? `Tracking For PO # ${poNumber}` : 'PO Tracking'}
      isOpen={isOpen}
      canEscapeKeyClose={true}
      autoFocus={true}
      className="dialog--po-tracking-form"
      style={{ width: '760px', maxWidth: '95vw' }}
    >
      <DialogSuspense>
        <PoTrackingDialogContent
          dialogName={dialogName}
          isOpen={isOpen}
          subscriptionForm={{ poId, poNumber }}
        />
      </DialogSuspense>
    </Dialog>
  );
}

export default compose(withDialogRedux())(PoTrackingDialog);
